import fetch from "isomorphic-fetch";
import randomNumberGenerator from "../../utils";

const React = require("react");
const { Component } = require("react");
const { min, uniqBy, union, sortBy } = require("lodash");
const infographicIcon = require("./chart-icon.png");
const videoIcon = require("./video-icon.png");
require("./article-listings.css");
const { COMPREHENSIVE_INSIGHTS, Buckets } = require("../../constants");

const Article = props => {
  return (
    <div>
      <ul className="article-listing">
        {props.data.map((x, id) => (
          <li key={x.GUID + randomNumberGenerator(id)}>
            <a href={x.url} target="_blank" rel="noopener noreferrer">
              {x.image === "" ? <span /> : <img src={x.image} alt="" />}
              {x.type === "Video" ? (
                <img src={videoIcon} alt="" className="icon" />
              ) : null}
              {x.type === "Infographic" ? (
                <img src={infographicIcon} alt="" className="icon" />
              ) : null}
              {x.title}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

const ViewMore = props => {
  return (
    <div className="articles">
      <span className="articles-line" />
      <button
        type="button"
        className="view-more-profile-type"
        onClick={() => props.handleClick(props.ArticlesType)}
      >
        {props.message}
        <span>{props.icon}</span>
      </button>
    </div>
  );
};

const getLoading = () => {
  return (
    <div id="inTurnFadingTextG">
      <div id="inTurnFadingTextG_1" className="inTurnFadingTextG">
        L
      </div>
      <div id="inTurnFadingTextG_2" className="inTurnFadingTextG">
        o
      </div>
      <div id="inTurnFadingTextG_3" className="inTurnFadingTextG">
        a
      </div>
      <div id="inTurnFadingTextG_4" className="inTurnFadingTextG">
        d
      </div>
      <div id="inTurnFadingTextG_5" className="inTurnFadingTextG">
        i
      </div>
      <div id="inTurnFadingTextG_6" className="inTurnFadingTextG">
        n
      </div>
      <div id="inTurnFadingTextG_7" className="inTurnFadingTextG">
        g
      </div>
      <div id="inTurnFadingTextG_8" className="inTurnFadingTextG">
        .
      </div>
      <div id="inTurnFadingTextG_9" className="inTurnFadingTextG">
        .
      </div>
      <div id="inTurnFadingTextG_10" className="inTurnFadingTextG">
        .
      </div>
    </div>
  );
};

class ArticleListings extends Component {
  constructor() {
    super();
    this.state = {
      viewMoreProfileType: false,
      viewMoreIndustryType: false,
      jsonFMGProfile: [],
      jsonFMGIndustry: [],
      jsonComprehensive: [],
      jsonFMGIndustryFlag: [],
      loadingProfile: true,
      loadingIndustry: true,
      result: [],
      isBucketsDataSet: false
    };
    this.handleClick = this.handleClick.bind(this);
  }

  componentDidMount() {
    // const profileURL = `${this.props.jsonConfig.serverURL}json/${this.props.selectedProfileType.articleFeed}`;
    const industryURL = `${this.props.jsonConfig.serverURL}json/${this.props.selectedIndustryType.articleFeed}`;
    const scalingURL = `${this.props.jsonConfig.serverURL}json/${COMPREHENSIVE_INSIGHTS.Scaling}`;
    const strategyURL = `${this.props.jsonConfig.serverURL}json/${COMPREHENSIVE_INSIGHTS.Strategy}`;
    const businessURL = `${this.props.jsonConfig.serverURL}json/${COMPREHENSIVE_INSIGHTS.Business}`;
    const enablersURL = `${this.props.jsonConfig.serverURL}json/${COMPREHENSIVE_INSIGHTS.Enablers}`;
    const orchestrationURL = `${this.props.jsonConfig.serverURL}json/${COMPREHENSIVE_INSIGHTS.Orchestration}`;

    // fetch(profileURL)
    //   .then(response => response.json())
    //   .then(responseJson => {
    //     this.setState({
    //       jsonFMGProfile: responseJson,
    //       loadingProfile: false
    //     });
    //   })
    //   .catch(error => {
    //     console.error(error);
    //   });
    fetch(industryURL)
      .then(response => response.json())
      .then(responseJson => {
        this.setState({
          jsonFMGIndustry: Array.isArray(responseJson) ? responseJson : [],
          loadingProfile: false
        });
      })
      .catch(error => {
        console.error(error);
      });
    this.fetchUrlForIndustry(scalingURL, Buckets.Scaling);
    this.fetchUrlForIndustry(strategyURL, Buckets.Strategy);
    this.fetchUrlForIndustry(businessURL, Buckets.Business);
    this.fetchUrlForIndustry(enablersURL, Buckets.Enablers);
    this.fetchUrlForIndustry(orchestrationURL, Buckets.Orchestration);
  }

  componentDidUpdate() {
    const { jsonFMGIndustryFlag, isBucketsDataSet } = this.state;
    if (jsonFMGIndustryFlag.length === 5 && !isBucketsDataSet) {
      this.getComprehensiveInsights();
    }
  }

  /** Algorithm for Comprehensive Insights :-
             *
             *  Assume that the result values from the survey are :-
                    1. Strategy: A
                    2. Business Model: B
                    3. Enablers: C
                    4. Orchestration: D

                Based on these results, take the following steps :-
                    1. Block 1 = Scaling a digital transformation.

                    2. Find minimum between A:D; say the minimum is A [Note that the remainder of the steps
                    are written assuming A is minimum as an example; if B were the minimum instead you would
                    switch out the algorithm accordingly].

                    3. Since minimum is A, Block 2 = A or strategy.

                    4. Next check the following three conditions :-
                        B - A <= 0.5
                        C - A <= 0.5
                        D - A <= 0.5

                    5. If none of the above meet this criteria, all the remainder blocks are A or strategy.

                    6. If only 1 of B, C, D satisfy the above criteria, Block 3 will be strategy, and Block 4
                    will be the one that meets this criteria (e.g. if B meets this criteria only, block 4
                    will be business model).

                    7. If 2+ of B,C,D satisfy the above criteria, Block 3 and 4 will be the ones that meet
                    this criteria, prioritized based on which of B, C, D have the smallest delta to A.
                        e.g. if B, C and D meet the criteria, but D-A < C-A < B-A , then block 3 will be D
                    or orchestration, block 4 will be C or enablers.

                */
  getComprehensiveInsights() {
    const bucketArr = [];
    const { data } = this.props.data.datasets[2];
    const minValue = min(data);
    let insightArray = [];
    bucketArr.push({ name: Buckets.Scaling, count: 1, diff: -1 });
    bucketArr.push({ name: Buckets.Strategy, count: 0, value: data[0] });
    bucketArr.push({ name: Buckets.Business, count: 0, value: data[1] });
    bucketArr.push({ name: Buckets.Enablers, count: 0, value: data[2] });
    bucketArr.push({ name: Buckets.Orchestration, count: 0, value: data[3] });

    bucketArr.forEach(element => {
      if (!element.diff) {
        // eslint-disable-next-line no-param-reassign
        element.diff = element.value - minValue;
      }
    });

    let permissibleBuckets = bucketArr.filter(x => x.diff <= 0.5);
    permissibleBuckets = sortBy(permissibleBuckets, ["diff"]);

    switch (permissibleBuckets.length) {
      case 2:
        permissibleBuckets[1].count = 3;
        break;
      case 3:
        permissibleBuckets[1].count = 2;
        permissibleBuckets[2].count = 1;
        break;
      case 4:
      case 5:
        permissibleBuckets[1].count = 1;
        permissibleBuckets[2].count = 1;
        permissibleBuckets[3].count = 1;
        break;
      default:
        break;
    }

    permissibleBuckets.forEach(x => {
      if (this.state[x.name].length > 0) {
        insightArray = insightArray.concat(
          this.state[x.name].slice(0, x.count)
        );
      }
    });

    let jsonComprehensive = union(insightArray, []);
    bucketArr.forEach(x => {
      jsonComprehensive = union(jsonComprehensive, this.state[x.name]);
    });
    jsonComprehensive = uniqBy(jsonComprehensive, "GUID");
    this.setState({
      jsonComprehensive,
      isBucketsDataSet: true
    });
  }

  fetchUrlForIndustry(url, industry) {
    fetch(url)
      .then(response => response.json())
      .then(responseJson => {
        const { jsonFMGIndustryFlag } = this.state;
        jsonFMGIndustryFlag.push(true);
        this.setState({
          [industry]: responseJson,
          loadingIndustry: false,
          jsonFMGIndustryFlag
        });
      })
      .catch(error => {
        console.error(error);
      });
  }

  handleClick(type) {
    const { viewMoreIndustryType, viewMoreProfileType } = this.state;
    if (type === "profile") {
      this.setState({
        viewMoreProfileType: !viewMoreProfileType
      });
    } else if (type === "industry") {
      this.setState({
        viewMoreIndustryType: !viewMoreIndustryType
      });
    }
  }

  render() {
    return (
      <div className="article-listings-container">
        <h1>Selected resources to help you move forward</h1>
        <div className="container-red-line">
          <span className="separation-red-line" />
        </div>

        <h2>comprehensive insights</h2>
        {this.state.jsonFMGProfile === "" ? (
          <div className="insights-link-container">
            <a
              className="insights-link"
              href="https://www.bain.com/publications/index.aspx"
              target="_blank"
              rel="noopener noreferrer"
            >
              More insights from Bain{"'"}s experts
            </a>
          </div>
        ) : (
          <div>
            {this.state.loadingProfile === false ? (
              <span>
                {/* {this.state.viewMoreProfileType ? <Article jsonFMGProfile={this.state.jsonFMGProfile} /> : <Article jsonFMGProfile={this.state.jsonFMGProfile} />} */}
                {
                  <Article
                    data={
                      this.state.viewMoreProfileType
                        ? this.state.jsonComprehensive
                        : this.state.jsonComprehensive.slice(0, 4)
                    }
                  />
                }
                <ViewMore
                  handleClick={this.handleClick}
                  ArticlesType="profile"
                  message={this.state.viewMoreProfileType ? "Less" : "More"}
                  icon={this.state.viewMoreProfileType ? " --" : " +"}
                />
              </span>
            ) : (
              getLoading()
            )}
          </div>
        )}
        <h2>industry insights</h2>
        {this.state.jsonFMGIndustry === "" ? (
          <div className="insights-link-container">
            <a
              className="insights-link"
              href="https://www.bain.com/publications/index.aspx"
              target="_blank"
              rel="noopener noreferrer"
            >
              More insights from Bain{"'"} experts
            </a>
          </div>
        ) : (
          <div>
            {this.state.loadingIndustry === false ? (
              <span>
                {
                  <Article
                    data={
                      this.state.viewMoreIndustryType
                        ? this.state.jsonFMGIndustry
                        : this.state.jsonFMGIndustry.slice(0, 4)
                    }
                  />
                }
                <ViewMore
                  handleClick={this.handleClick}
                  ArticlesType="industry"
                  message={this.state.viewMoreIndustryType ? "Less" : "More"}
                  icon={this.state.viewMoreIndustryType ? " --" : " +"}
                />
              </span>
            ) : (
              getLoading()
            )}
          </div>
        )}
      </div>
    );
  }
}

export default ArticleListings;



// WEBPACK FOOTER //
// ./src/components/Results/article-listings.js